import * as Action from './action';

const defineInitialState = () => ({
  data: [],
  total: 0,
  unReaded: false,
});

export function reducer(state = defineInitialState(), action) {
  switch (action.type) {
    case Action.$reset.ACTION:
      return defineInitialState();
    case Action.$newNotif.ACTION:
      let nd = state.data;
      nd.push(action.payload);

      return {
        data: nd,
        total: state.total + 1,
        unReaded: true,
        ...state,
      };
    case Action.$get.SUCCESS:
      return {
        data: action.response?.data,
        total: action.response?.total,
        unReaded: action.response?.total > 0,
      };
    case Action.$markRead.SUCCESS:
      let newData = [];
      state?.data?.forEach((c, i) => {
        let nd = c;
        if (c?.id === action.id) {
          nd.is_readed = true;
        }

        newData.push(nd);
      });

      return {
        total: state.total - 1,
        unReaded: state.total - 1 > 0,
        data: newData,
      };
    default:
      return state;
  }
}

export function persister({ data, unReaded, total }) {
  return { data, unReaded };
}
